import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import axios from "axios";
import moment from "moment";
import CatalogoProducto from "../../catalogos/catalogoProductosAlmacen";
import { validaSoloNumero } from "../../util/varios";
import CatalogoProveedor from "../../catalogos/catalogoProveedor";

const ImpCompraAlmacen = (props) => {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const checkDemo1 = useRef();
  const checkDemo2 = useRef();
  const cmbDenominacion = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtId = useRef();
  const txtDes = useRef();
  const checkCompra = useRef();
  const checkServi = useRef();
  const checkTodo = useRef();
  const checkTodoProve = useRef();
  const checkUnoProve = useRef();
  const txtIdProve = useRef();
  const txtDesProve = useRef();
  // const txtDia = useRef();

  const btnCancela = useRef();
  const [dataProve, setDataProve] = useState();
  const [indexPro, setIndexPro] = useState();
  const [vistaDemo, setVistaDemo] = useState("collapse");
  const [vistaProve, setVistaProve] = useState("visivle");
  // const [producto, setProducto] = useState();

  const [mostrarProductos, setMostarProductos] = useState(false);
  const [mostrarProve, setMostrarProve] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [activate, setActivate] = useState(false);
  // const [values, setValues] = useState({});
  // const [itemSelect, setItemSelect] = useState(-1);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState();
  // const [records, setRecords] = useState([]);
  // const [filterFn, setFilterFn] = useState({
  //   fn: (items) => {
  //     return items;
  //   },
  // });

  const blanquear = () => {};

  const cancelar = () => {
    blanquear();
    props.setShow(false);
    props.cerrar();
  };

  const onChangeValidar = () => {
    let sigue = true;

    // console.log(operacion)
    if (
      operacion === 102 &&
      vistaDemo === "visible" &&
      cmbDenominacion.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar un tipo de denominación",
        icono: "informacion",
      });
      sigue = false;
      cmbDenominacion.current.focus();
    } else if (
      operacion === 103 ||
      operacion === 104 ||
      operacion === 105 ||
      operacion === 106 ||
      operacion === 106 ||
      operacion === 109
    ) {
      if (operacion === 104 && txtId.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "De ingresar un producto",
          icono: "informacion",
        });
        sigue = false;
        txtId.current.focus();
      } else if (
        parseInt(moment.utc(txtDesde.current.value).format("YYYY")) >
        parseInt(moment.utc(txtHasta.current.value).format("YYYY"))
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La fecha hasta no debe ser menor a la fecha desde",
          icono: "informacion",
        });
        sigue = false;
        txtHasta.current.focus();
      } /* if(operacion === 6 && txtIdProve.current.value === ''){
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'De ingresar un Proveedor', icono: 'informacion' })
        sigue = false;
        txtIdProve.current.focus()
      } */
    }

    /* if(operacion === 2) */

    if (sigue) {
      if (operacion === 102) {
        var sql;
        var sql2;
        var sql3;
        var sql4;
        var tipoprove = 0;
        var combo = indexPro;

        if (checkDemo2.current.checked) {
          console.log("uno solo");
          sql = "DENOMINACIONCOMERCIAL=" + combo;
          sql3 = tipoprove;
          sql4 = "LISTADO DE " + cmbDenominacion.current.value;
        } else {
          console.log("todo");

          sql = "TRUE";
          sql3 = tipoprove;
          sql4 = "LISTADO GENERAL";
        }

        window.open(
          `${op.reportes + "/comprasyalmacen?"}reporte=Ing_Contratista&CONDICION=${sql}&TIT_RG01=${sql4}&TIPO=${sql3}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else if (operacion === 103) {
        var val2 = moment.utc(txtDesde.current.value).format("DD-MM-YYYY");
        var val3 = moment.utc(txtHasta.current.value).format("DD-MM-YYYY");
        var sql;
        var sql2 = null;
        sql =
          "ORD.Fecha Between '" +
          val2 +
          "' AND '" +
          val3 +
          "' AND ORD.IDEFISCAL=" +
          idefiscal;
        sql2 = "DESDE EL '" + val2 + "' HASTA EL '" + val3 + "'";

        window.open(
          `${op.reportes + "/comprasyalmacen?"}reporte=Proveedores_activos&efiscal=${idefiscal}&CONDICION=${sql}&TIT_RGO1=${sql2}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else if (operacion === 104) {
        var sql;
        var desde = moment.utc(txtDesde.current.value).format("DD-MM-YYYY");
        var hasta = moment.utc(txtHasta.current.value).format("DD-MM-YYYY");

        sql =
          "OD.idproducto = " +
          txtId.current.value +
          " AND O.Fecha Between '" +
          desde +
          "' AND '" +
          hasta +
          "'";

        window.open(
          `${op.reportes + "/comprasyalmacen?"}reporte=Productos_Proveedor&CONDICION=${sql}&efiscal=${idefiscal}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else if (operacion === 105) {
        var val2 = moment.utc(txtDesde.current.value).format("DD-MM-YYYY");
        var val3 = moment.utc(txtHasta.current.value).format("DD-MM-YYYY");
        var sql;
        var sql2;
        var sql3;

        if (checkTodo.current.checked) {
          console.log("todo");
          sql3 = "true";
        } else if (checkCompra.current.checked) {
          console.log("compra");

          sql3 = "OCP.tipo = 0";
        } else {
          console.log("servicio");
          sql3 = "OCP.tipo = 1";
        }

        sql = "OCP.Fecha Between '" + val2 + "' AND '" + val3 + "' AND " + sql3;
        sql2 = "DESDE EL '" + val2 + "' HASTA EL '" + val3 + "'";

        if (espiritu !== 14 || espiritu !== 9) {
          window.open(
            `${op.reportes + "/comprasyalmacen?"}reporte=OrdenCompra_Prov2&efiscal=${idefiscal}&CONDICION=${sql}&TIT_RGO1=${sql2}`,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
          );
        } else {
          if (checkTodo.current.checked) {
            window.open(
              `${op.reportes + "/comprasyalmacen?"}reporte=OrdenCompra_Prov2_1_Gen&efiscal=${idefiscal}&CONDICION=${sql}&TIT_RGO1=${sql2}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
            );
          } else {
            window.open(
              `${op.reportes + "/comprasyalmacen?"}reporte=OrdenCompra_Prov2_1&efiscal=${idefiscal}&CONDICION=${sql}&TIT_RGO1=${sql2}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
            );
          }
        }
      } else if (operacion === 106) {
        var val2 = moment.utc(txtDesde.current.value).format("DD-MM-YYYY");
        var val3 = moment.utc(txtHasta.current.value).format("DD-MM-YYYY");
        var sql;
        var sql2;
        var sql3;

        if (checkUnoProve.current.checked) {
          sql3 = "OCP.idproveedor = " + txtIdProve.current.value;
        } else {
          sql3 = "true";
        }

        sql = "OCP.Fecha Between '" + val2 + "' AND '" + val3 + "' ";
        sql2 = "DESDE EL '" + val2 + "' HASTA '" + val3 + "'";

        window.open(
          `${op.reportes + "/comprasyalmacen?"}reporte=OrdenCompra_Prov1&efiscal=${idefiscal}&CONDICION=${sql}&TIT_RGO1=${sql2}&PROVEEDOR=${sql3}&VIENE=${espiritu}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else if (operacion === 108) {
        var val2 = moment.utc(txtDesde.current.value).format("DD-MM-YYYY");
        var val3 = moment.utc(txtHasta.current.value).format("DD-MM-YYYY");
        var sql;
        var sql2;
        var sql3;
        sql = "Fecha Between '" + val2 + "' AND '" + val3 + "' ";
        sql2 = "DESDE EL '" + val2 + "' HASTA '" + val3 + "'";

        window.open(
          `${op.reportes + "/comprasyalmacen?"}reporte=ListOrdenCompra&efiscal=${idefiscal}&CONDICION=${sql}&TIT_RGO1=${sql2}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      } else if (operacion === 109) {
        var val2 = moment.utc(txtDesde.current.value).format("DD-MM-YYYY");
        var val3 = moment.utc(txtHasta.current.value).format("DD-MM-YYYY");
        var sql;
        var sql2;
        var sql3;
        sql = "Fecha Between '" + val2 + "' AND '" + val3 + "' ";
        sql2 = "DESDE EL '" + val2 + "' HASTA '" + val3 + "'";

        window.open(
          `${op.reportes + "/comprasyalmacen?"}reporte=ListOrdenCompra&efiscal=${idefiscal}&CONDICION=${sql}&TIT_RGO1=${sql2}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
        );
      }
    }
  };

  const seleccionarProveedores = () => {
    let campos = "iddenominacioncomercial,TRIM(descripcion) as descripcion";
    let nomtab = "denominacioncomercial";
    let orden = "iddenominacioncomercial";

    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setDataProve(response.data);
          console.log(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        /*  setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
         */
        setActivate(false);
      });
  };

  const agregarProducto = (values) => {
    seleccionarRegistroTipReten(values);
  };

  const seleccionarRegistroTipReten = (id) => {
    setMostarProductos(false);

    let campos = "*";
    let nomtab = "producto";
    let nomid = "idproducto";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    console.log(endpoint);

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtId.current.value = response.data.idproducto;
            txtDes.current.value = response.data.descripcion;
          } else {
            setActivo(true);

            /* setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un Tipo de Retención con este codigo', icono: 'informacion' });
             */
            txtId.current.value = "";
            txtDes.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        /*    setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' }); */
      });
  };

  const seleccionarRegistroTipReten2 = (id) => {
    setMostrarProve(false);
    let campos = "*";
    let nomtab = "proveedor";
    let nomid = "idproveedor";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    console.log(endpoint);

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            console.log(response.data);
            txtIdProve.current.value = response.data.idproveedor;
            txtDesProve.current.value =
              response.data.razonsocial + " / " + response.data.rif;
          } else {
            setActivo(true);

            /* setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un Tipo de Retención con este codigo', icono: 'informacion' });
             */
            txtIdProve.current.value = "";
            txtDesProve.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        /*    setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' }); */
      });
  };

  const validarTipoReten = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistroTipReten(event.target.value);
      } else {
        txtId.current.value = "";
        txtDes.current.value = "";
      }
    }
  };

  const validarTipoReten2 = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistroTipReten2(event.target.value);
      } else {
        txtIdProve.current.value = "";
        txtDesProve.current.value = "";
      }
    }
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion === 102) {
          seleccionarProveedores();
        } /* else if(props.operacion === 3){
          txtDesde.current.focus()
        } */
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>
          {operacion === 102
            ? "Listado de Proveedores de Bienes y Servicios ."
            : operacion === 103
              ? "Listado de Activos por Periodos."
              : operacion === 104
                ? "Precios de Productos por Proveedor."
                : operacion === 105
                  ? "Listado General Ordenes de Compras y Servicios."
                  : operacion === 106
                    ? "Listado Ordenes de Compra por Proveedor."
                    : operacion === 107
                      ? "Estado Mensual por Departamento."
                      : operacion === 108
                        ? "Listado de Requisiciones."
                        : operacion === 109
                          ? "Socilicitudes de Compas."
                          : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CatalogoProducto
          show={mostrarProductos}
          onHideCancela={() => {
            setMostarProductos(false);
          }}
          onHideAcepta={agregarProducto}
        />

        <CatalogoProveedor
          show={mostrarProve}
          onHideCancelaCatProv={() => {
            setMostrarProve(false);
          }}
          onHideAceptaCatProv={seleccionarRegistroTipReten2}
          imp={1}
        />

        <div className="col-md-12 mx-auto row px-0">
          {operacion === 102 ? (
            <fieldset className=" row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
              <legend className="float-none w-auto">
                Selección Tipos de Denominación Comercial
              </legend>

              <div class="form-check col">
                <input
                  class="form-check-input my-auto"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  defaultChecked
                  onClick={() => {
                    setVistaDemo("collapse");
                  }}
                  ref={checkDemo1}
                />
                <label class="form-check-label my-auto" for="flexRadioDefault1">
                  Todos
                </label>
              </div>

              <div class="form-check col">
                <input
                  class="form-check-input my-auto"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  onClick={() => {
                    setVistaDemo("visible");
                  }}
                  ref={checkDemo2}
                />
                <label class="form-check-label my-auto" for="flexRadioDefault2">
                  Tipo Denominación
                </label>
              </div>
            </fieldset>
          ) : (
            ""
          )}

          {operacion === 102 ? (
            <div
              class="input-group input-group-sm mb-2 col-md-12 px-0 mt-2"
              style={{ visibility: vistaDemo }}
            >
              <span class="input-group-text" id="inputGroup-sizing-sm">
                Tipo de Denominación:
              </span>

              <select class="form-select" ref={cmbDenominacion}>
                <option value="">Seleccionar</option>
                {dataProve &&
                  dataProve.map((item, index) => (
                    <option
                      key={index}
                      value={item.descripcion}
                      onClick={() => {
                        setIndexPro(index + 1);
                      }}
                    >
                      {item.descripcion}
                    </option>
                  ))}
              </select>
            </div>
          ) : (
            ""
          )}
          {operacion === 104 ? (
            <fieldset className=" row col-md-12 mb-2 border-azul rounded mx-auto d-flex justify-content-between">
              <legend className="float-none w-auto ">Producto</legend>
              <div class="input-group input-group-sm mb-2 col-md-12 mx-auto">
                <input
                  type="text"
                  class="form-control col-md-2"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  onKeyUp={validarTipoReten}
                  onBlur={validarTipoReten}
                  ref={txtId}
                />

                <button
                  type="button"
                  onClick={() => {
                    setMostarProductos(true);
                  }}
                  class="btn btn-success"
                >
                  <i className="fas fa-search"></i>
                </button>

                <input
                  type="text"
                  class="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  disabled
                  ref={txtDes}
                />
              </div>
            </fieldset>
          ) : (
            ""
          )}

          {operacion === 103 ||
          operacion === 104 ||
          operacion === 105 ||
          operacion === 106 ||
          operacion === 108 ||
          operacion === 109 ? (
            <div class="col-md-12 row mx-auto px-0">
              <div class="input-group input-group-sm mb-2 col">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  Desde:
                </span>
                <input
                  type="date"
                  class="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  ref={txtDesde}
                  defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                />
              </div>
              <div class="input-group input-group-sm mb-2 col">
                <span class="input-group-text" id="inputGroup-sizing-sm">
                  Hasta:
                </span>
                <input
                  type="date"
                  class="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  ref={txtHasta}
                  defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                />
              </div>
            </div>
          ) : (
            ""
          )}

          {operacion === 105 ? (
            <fieldset className=" row col-md-12 border-azul rounded mx-auto d-flex justify-content-between">
              <legend className="float-none w-auto">Tipo de Solicitudes</legend>

              <div class="form-check col">
                <input
                  class="form-check-input my-auto"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  ref={checkTodo}
                  defaultChecked
                />
                <label class="form-check-label my-auto" for="flexRadioDefault1">
                  Todas
                </label>
              </div>

              <div class="form-check col">
                <input
                  class="form-check-input my-auto"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  ref={checkCompra}
                />
                <label class="form-check-label my-auto" for="flexRadioDefault1">
                  Compras
                </label>
              </div>

              <div class="form-check col">
                <input
                  class="form-check-input my-auto"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  ref={checkServi}
                />
                <label class="form-check-label my-auto" for="flexRadioDefault1">
                  Servicios
                </label>
              </div>
            </fieldset>
          ) : (
            ""
          )}

          {operacion === 106 ? (
            <div className="col-md-12 mx-auto row py-2">
              <div class="form-check col">
                <input
                  class="form-check-input my-auto"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  defaultChecked
                  ref={checkUnoProve}
                  onClick={() => {
                    setVistaProve("visible");
                  }}
                />
                <label class="form-check-label my-auto" for="flexRadioDefault1">
                  Seleccionar Proveedor
                </label>
              </div>

              <div class="form-check col">
                <input
                  class="form-check-input my-auto"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  ref={checkTodoProve}
                  onClick={() => {
                    setVistaProve("collapse");
                  }}
                />
                <label class="form-check-label my-auto" for="flexRadioDefault1">
                  Todos los Proveedores
                </label>
              </div>
            </div>
          ) : (
            ""
          )}

          {operacion === 106 ? (
            <fieldset
              className=" row col-md-12 mb-2 border-azul rounded mx-auto d-flex justify-content-between"
              style={{ visibility: vistaProve }}
            >
              <legend className="float-none w-auto">Proveedor</legend>
              <div class="input-group input-group-sm mb-2 col-md-12 mx-auto">
                <input
                  type="text"
                  class="form-control col-md-2"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  onKeyUp={validarTipoReten2}
                  onBlur={validarTipoReten2}
                  ref={txtIdProve}
                />

                <button
                  type="button"
                  class="btn btn-success"
                  onClick={() => {
                    setMostrarProve(true);
                  }}
                >
                  <i className="fas fa-search"></i>
                </button>

                <input
                  type="text"
                  class="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  disabled
                  ref={txtDesProve}
                />
              </div>
            </fieldset>
          ) : (
            ""
          )}
        </div>

        <Dimmer active={activate}></Dimmer>

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-primary rounded-pill"
          /* disabled={activo} */ onClick={onChangeValidar}
        >
          <i className="fas fa-print">Imprimir</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill "
        >
          <i className="fa"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImpCompraAlmacen;
